(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // La quantité saisie au clavier met le panier à jour sans bouton
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('#cart-form [data-cart-input]');
    if (input && input.form) input.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function closeAll(except) {
    document.querySelectorAll('.hs.is-open').forEach(function (h) {
      if (h !== except) { h.classList.remove('is-open'); var d = h.querySelector('.hs__dot'); if (d) d.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.hs__card')) { e.stopPropagation(); return; }
    var dot = e.target.closest('.hs__dot');
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      var h = dot.closest('.hs');
      closeAll(h);
      var open = h.classList.toggle('is-open');
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    closeAll(null);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

  function sync(value) {
    document.querySelectorAll('[data-vcompare]').forEach(function (box) {
      var idx = -1;
      box.querySelectorAll('[data-vc-pick]').forEach(function (b, i) {
        var on = b.getAttribute('data-vc-pick') === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) idx = i;
      });
      box.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.querySelectorAll('td').forEach(function (td, i) { td.classList.toggle('is-col', i === idx + 1); });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vc-pick]');
    if (b) {
      var v = b.getAttribute('data-vc-pick');
      var opt = Array.prototype.find.call(document.querySelectorAll('[data-variant-picker] .opt'), function (o) { return o.getAttribute('data-option-value') === v; });
      if (opt) opt.click();
      sync(v);
      return;
    }
    var o = e.target.closest('[data-variant-picker] .opt');
    if (o) setTimeout(function () { sync(o.getAttribute('data-option-value')); }, 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
